import React from 'react';
import { FadeIn } from './FadeIn';
import { BookMockup } from './BookMockup';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiShoppingCart } = FiIcons;

const AFFILIATE_URL = 'https://amzn.to/46L71gr';

function handleAmazonClick() {
  if (typeof window.trackAmazonClick === 'function') {
    window.trackAmazonClick('final_cta_section', 'Sichern Sie sich Ihr Exemplar');
  }
}

export const FinalCTA = () => {
  return (
    <section className="py-16 md:py-24 bg-navy relative overflow-hidden">
      <div className="absolute inset-0 opacity-5" style={{ backgroundImage: 'radial-gradient(#D4AF37 1px,transparent 1px)', backgroundSize: '30px 30px' }}></div>
      <div className="max-w-4xl mx-auto px-5 sm:px-8 lg:px-12 relative z-10 text-center">
        <FadeIn direction="up">
          <h2 className="font-serif text-3xl md:text-5xl text-white font-bold mb-5 leading-tight">
            Machen Sie Schluss mit dem Hoffen auf „bessere Zeiten".
          </h2>
          <p className="font-sans text-base md:text-xl text-gray-300 mb-10">
            Nehmen Sie Ihre finanzielle Zukunft selbst in die Hand. Sichern Sie sich jetzt Ihr Exemplar!
          </p>
          <div className="mb-10 flex justify-center">
            <BookMockup className="scale-90 md:scale-100" />
          </div>
          <div className="pb-20 md:pb-0">
            <a
              href={AFFILIATE_URL}
              target="_blank"
              rel="noopener noreferrer sponsored"
              onClick={handleAmazonClick}
              data-action="amazon-click"
              data-source="final_cta_section"
              className="inline-flex items-center gap-3 px-10 py-5 text-navy bg-gold font-sans font-bold text-lg rounded transition-all duration-300 shadow-[0_0_30px_rgba(212,175,55,0.4)] hover:shadow-[0_0_50px_rgba(212,175,55,0.7)] hover:scale-105 hover:brightness-110"
            >
              <SafeIcon icon={FiShoppingCart} className="text-xl" />
              Sichern Sie sich Ihr Exemplar
            </a>
          </div>
        </FadeIn>
      </div>
    </section>
  );
};